import { normalizeExperience } from './normalizeExperience';

/**
 * Whether an experience should appear under a home-screen category tab.
 * Hybrid entries (e.g. museum AR) can match multiple tabs from one record —
 * we never duplicate data, only broaden discovery filters.
 */
export function experienceMatchesCategory(rawExperience, categoryId) {
  if (!categoryId || categoryId === 'all') return true;
  if (!rawExperience) return false;

  const exp = normalizeExperience(rawExperience);
  if (!exp) return false;

  if (exp.category === categoryId) return true;

  if (categoryId === 'location-based') {
    return exp.isPhysicalVenue || exp.isLBE;
  }

  if (categoryId === 'augmented-reality') {
    return exp.primaryFormat === 'ar' || exp.primaryFormat === 'webxr';
  }

  return false;
}
